export const CREDITAS_WHATSAPP = 'https://wa.me/+525568269401/?text=Hola,';
export const CREDITAS_PHONE_NUMBER = 'tel:5568269401';
export const CREDITAS_EMAIL = 'mailto:ayuda@creditas.com';
